import { Box, Page, Stack } from 'braid-design-system';
import type { ReactNode } from 'react';

import { Footer } from '../Footer/Footer';
import { Header } from '../Header/Header';
import { LocalDemoBanner } from '../LocalDemoBanner/LocalDemoBanner';
import { UserPanel, type UserPanelProps } from '../UserPanel/UserPanel';

export type PageWrapperCurrentUser = UserPanelProps;

type PageWrapperProps = {
  children: ReactNode;
  currentUser?: PageWrapperCurrentUser;
};

export const PageWrapper = ({ children, currentUser }: PageWrapperProps) => (
  <Box background="customLight" style={{ backgroundColor: '#F8F9FA' }}>
    <Page footer={<Footer />}>
      <LocalDemoBanner />
      <Stack space="large">
        <Box>
          <Header />
          {currentUser ? (
            <UserPanel
              email={currentUser.email}
              onLogout={currentUser.onLogout}
            />
          ) : null}
        </Box>
        <Stack space="gutter">
          <Box paddingX={{ mobile: 'small', tablet: 'gutter', wide: 'none' }}>
            {children}
          </Box>
        </Stack>
      </Stack>
    </Page>
  </Box>
);
